import type { MarketTypeChoice } from "./marketType";

const LABEL: Record<MarketTypeChoice, string> = {
  all: "All markets",
  spot: "Spot",
  futures: "Futures",
  equity: "Stocks",
};

/**
 * The same three (or four) buttons on every list that holds both spot and
 * futures: bots, the league, strategies, published backtests, market data.
 * One control everywhere, so "show me only the leveraged futures" is always
 * the same click.
 */
export function MarketTypeFilter({
  value,
  onChange,
  stocks = false,
}: {
  value: MarketTypeChoice;
  onChange: (value: MarketTypeChoice) => void;
  /** Offer "Stocks" too, on lists that can hold SPY and QQQ. */
  stocks?: boolean;
}) {
  const choices: MarketTypeChoice[] = stocks
    ? ["all", "spot", "futures", "equity"]
    : ["all", "spot", "futures"];
  return (
    <div className="segmented" role="group" aria-label="Market type">
      {choices.map((c) => (
        <button
          key={c}
          type="button"
          className={value === c ? "is-active" : undefined}
          aria-pressed={value === c}
          onClick={() => onChange(c)}
        >
          {LABEL[c]}
        </button>
      ))}
    </div>
  );
}
